import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';

import ContextMenu from '../../components/context_menu/context_menu';
import contextMenuConnector from '../../components/context_menu/context_menu_connector';
import type { GetDefinition } from '../../components/context_menu/types';
import contextMenuCollectionOptions from '../../components/search_items/context_menu_collection_options';
import contextMenuShareOptions from '../../components/search_items/context_menu_share_options';
import { getContextItemsAttributes } from '../../components/search_items/context_menu_utils';
import { SHARE_COLLECTION_PAGE_ROUTE } from '../../constants/routes';
import {
  CONTEXT_MENU_COLLECTION_TREE,
  connectContextMenuConsumer,
} from '../../contexts/context_menu';
import { UUID_ZERO } from '../../utils/tree_handlers';

export const getDefinition: GetDefinition<SearchItemEntity> = (
  props,
  state,
) => {
  const contextItems = props.contextItems;

  const filteredItems = contextItems.filter((obj) => obj.id !== UUID_ZERO);
  if (filteredItems.length === 0) {
    return {
      items: [],
    };
  }

  // Should only ever be triggered with one item from the collection tree
  // but check and set parent id as fromCollectionId for the custom action
  let collectionId;
  if (filteredItems.length === 1) {
    collectionId = filteredItems.at(0)?.id ?? undefined;
  }

  const attributes = getContextItemsAttributes(
    state,
    contextItems,
    collectionId,
  );

  if ([SHARE_COLLECTION_PAGE_ROUTE].includes(state.routeParams.route)) {
    return {
      items: contextMenuShareOptions(
        state,
        props.contextItems,
        attributes,
        true,
      ),
    };
  }

  return {
    items: contextMenuCollectionOptions(state, props.contextItems, attributes),
  };
};

const CollectionTreeContextMenu = connectContextMenuConsumer(
  contextMenuConnector(getDefinition)(ContextMenu),
  CONTEXT_MENU_COLLECTION_TREE,
);

export default CollectionTreeContextMenu;
